import React from 'react'
import TravelPackages from '../Components/TravelPackage/TravelPackages'
import HeroSection from '../Components/HeroSection'
import TravelCard from '../Components/Card/Card'
import DoubtSection from '../Components/QuoteSection'
import CarouselBanner from '../Components/Carousel'
import TourPackages from '../Components/Card/AboutCard/AboutCard' 
import Footer from '../Components/Footer/Footer'

const Home = () => {
  return (
    <div>
        <HeroSection/>
        <TravelPackages />
        <TourPackages/>
        <DoubtSection/>
        <Footer/>
    </div>
  )
}

export default Home